import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { fuseAnimations } from '@fuse/animations';
import { PlatformService } from 'app/core/platform/platform.service';
import { PlatformSettings } from 'app/core/platform/platform.types';
import { UserManagementService } from 'app/modules/partner/user-management/user-management.service';
import { PaymentsService } from 'app/modules/user/payments/payments.service';
import { UserExpense } from 'app/modules/user/payments/payments.types';
import { ReleasesService } from 'app/modules/user/releases/releases.service';
import { AudioFormat, Release } from 'app/modules/user/releases/releases.types';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-release-summary-modal',
    templateUrl: './release-summary-modal.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: fuseAnimations,
})
export class ReleaseSummaryModal implements OnInit, AfterViewInit, OnDestroy {
    isLoading: boolean;
    platform: PlatformSettings;
    release: Release;
    releaseUuid: string;

    expenseForm: FormGroup;

    private _unsubscribeAll: Subject<any> = new Subject<any>();

    constructor(
        public matDialogRef: MatDialogRef<ReleaseSummaryModal>,
        private _changeDetectorRef: ChangeDetectorRef,
        public userManagementService: UserManagementService,
        public paymentsService: PaymentsService,
        public platformService: PlatformService,
        private _formBuilder: FormBuilder,
        private _platformService: PlatformService,
        public releasesService: ReleasesService,
        @Inject(MAT_DIALOG_DATA) public data: any,
    ) {
    }

    ngOnInit(): void {
        this._platformService.platform$.pipe(takeUntil(this._unsubscribeAll)).subscribe(platform => this.platform = platform);
        this.release = this.data.release;
        this.release = this.releasePostProcessing(this.release);
        this.releaseUuid = this.data.releaseUuid;
        if (!this.release && this.releaseUuid) {
            this.releasesService.getReleaseById(this.releaseUuid).subscribe(release => {
                release = this.releasePostProcessing(release);
                this.release = release;
                this._changeDetectorRef.markForCheck();
            });
        }
        this._changeDetectorRef.markForCheck();
    }

    releasePostProcessing(release?: Release): Release {
        if (!release) {
            return undefined;
        }

        release.tracks.forEach((track) => {
            track.audioFile = track.audioFiles.find(f => f.type === AudioFormat.Master)
            track.acrCloudResults?.sort((a, b) => a.sampleStartMs - b.sampleStartMs);
        });
        return release;
    }

    closeModal(): void {
        this.matDialogRef.close();
    }


    ngAfterViewInit(): void {
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    catchEnter(event): void {
        if (event.key === "Enter") {
            event.preventDefault();
            event.stopPropagation();
        }
    }

    stopPropagation(event) {
        //This function is needed to prevent the blur event from firing when the user clicks on the autocomplete options
        event.preventDefault();
        event.stopPropagation();
    }

    trackByFn(index: number, item: any): any {
        return item.uuid || index;
    }
}
